import fishionService from '../../services/fishion';

export default {
  state: {
    fishionInventoryCalcs: [],
    fishionShippingInformation: [],
    fishionReturnShippingInformation: {},
    fishionPackingInfo: {},
    fishionQuotesToImport: [],
    fishionAndyMarkCash: {},
  },

  getters: {
    fishionInventoryCalcs: state => state.fishionInventoryCalcs,
    fishionShippingInformation: state => state.fishionShippingInformation,
    fishionReturnShippingInformation: state => state.fishionReturnShippingInformation,
    fishionPackingInfo: state => state.fishionPackingInfo,
    fishionQuotesToImport: state => state.fishionQuotesToImport,
    fishionAndyMarkCash: state => state.fishionAndyMarkCash,
  },

  mutations: {
    GET_FISHION_INV_CALCS(state, salesOrder) {
      state.fishionInventoryCalcs = salesOrder;
    },
    SET_FISHION_SHIPPING_INFORMATION(state, shippingInfo) {
      state.fishionShippingInformation = shippingInfo;
    },
    SET_FISHION_RETURN_SHIPPING_INFORMATION(state, shippingInfo) {
      state.fishionReturnShippingInformation = shippingInfo;
    },
    GET_FISHION_QUOTES_TO_IMPORT(state, quotes) {
      state.fishionQuotesToImport = quotes;
    },
    GET_ANDY_MARK_CASH(state, cashInfo) {
      state.fishionAndyMarkCash = cashInfo;
    },
    SET_FISHION_PACKING_INFO(state, packingInfo) {
      state.fishionPackingInfo = packingInfo;
    },
  },

  actions: {
    searchFishion: ({ commit }, payload) => {
      fishionService.searchInventoryCalculations(payload).then((response) => {
        commit('GET_FISHION_INV_CALCS', response);
      });
    },
    searchFishionForErrors: ({commit}) => {
      fishionService.getInventoryCalculationErrors().then((response) => {
        commit('GET_FISHION_INV_CALCS', response);
      });
    },
    getFishionShippingInformation: ({ commit }, orderNumber) => {
      fishionService.getShippingInformation(orderNumber).then(response =>
        commit('SET_FISHION_SHIPPING_INFORMATION', response));
    },
    getFishionReturnShippingInformation: ({ commit }, orderNumber) => {
      fishionService.getReturnShippingInformation(orderNumber).then(response =>
        commit('SET_FISHION_RETURN_SHIPPING_INFORMATION', response));
    },
    getFishionPackingInfo: ({ commit }, shipItemIds) => {
      fishionService.getPackingInfo(shipItemIds).then((response) => {
        commit('SET_FISHION_PACKING_INFO', response);
      });
    },
    getFishionAndyMarkCash: ({ commit }, orderNumber) => {
      fishionService.getAndyMarkCash(orderNumber).then((response) => {
        commit('GET_ANDY_MARK_CASH', response);
      });
    },
    getFishionQuotesToImport: ({ commit }) => {
      fishionService.getQuotesToImport().then((response) => {
        commit('GET_FISHION_QUOTES_TO_IMPORT', response);
      });
    },
  },
};



// WEBPACK FOOTER //
// /src/store/modules/fishion.js